import { render, staticRenderFns } from "./UserFormLanguage.vue?vue&type=template&id=41ac58dd"
import script from "./UserFormLanguage.vue?vue&type=script&lang=js"
export * from "./UserFormLanguage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports